import Swiper from 'swiper'

import {
  Navigation as SwiperNavigation,
  Pagination,
  Thumbs,
  FreeMode,
  Autoplay,
} from 'swiper/modules'

//import css swiperjs modules
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'
import 'swiper/css/free-mode'
import 'swiper/css/autoplay'

import Alpine from 'alpinejs'

window.Alpine = Alpine
window.SwiperNavigation = SwiperNavigation //remove conflict with global javascript Navigation object
window.Pagination = Pagination
window.Thumbs = Thumbs
window.FreeMode = FreeMode
window.Autoplay = Autoplay
window.Swiper = Swiper

Alpine.start()
